export default __webpack_public_path__ + "static/media/AdvancedSearchCard.0dc4b8238d3c877e.svg";